"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/credit-score-changelog.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Fcredit-score-changelog.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.scoreStatusToJSON = exports.scoreStatusFromJSON = exports.CreditScoreDetails = exports.CreditScoreChangelog = exports.ScoreStatus = void 0;
const insight_1 = require("./insight");
const protobufPackage = 'com.step.creditreport.proto';
var ScoreStatus;
(function (ScoreStatus) {
    ScoreStatus["INVALID_SCORE_STATUS"] = "INVALID_SCORE_STATUS";
    /**
     * PRESENT - Credit score is available for this user.
     */
    ScoreStatus["PRESENT"] = "PRESENT";
    /**
     * NO_HIT - Credit score is not available, user was not found in the bureau's system.
     */
    ScoreStatus["NO_HIT"] = "NO_HIT";
    /**
     * MISSING_SCORE_DATA - Credit score is not available, bureau does not have enough information
     * to create a credit score for this user
     */
    ScoreStatus["MISSING_SCORE_DATA"] = "MISSING_SCORE_DATA";
    /**
     * NOT_PRESENT_OTHER - Credit score is not available for other reasons.
     */
    ScoreStatus["NOT_PRESENT_OTHER"] = "NOT_PRESENT_OTHER";
    ScoreStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ScoreStatus || (exports.ScoreStatus = ScoreStatus = {}));
function createBaseCreditScoreChangelog() {
    return { details: exports.CreditScoreDetails.fromPartial({}) };
}
exports.CreditScoreChangelog = {
    fromJSON(object) {
        const message = {
            details: isSet(object.details)
                ? exports.CreditScoreDetails.fromJSON(object.details)
                : exports.CreditScoreDetails.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.details !== undefined) {
            obj.details = exports.CreditScoreDetails.toJSON(message.details);
        }
        return obj;
    },
    create(base) {
        return exports.CreditScoreChangelog.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditScoreChangelog();
        message.details = (object.details !== undefined && object.details !== null)
            ? exports.CreditScoreDetails.fromPartial(object.details)
            : exports.CreditScoreDetails.fromPartial({});
        return message;
    },
};
function createBaseCreditScoreDetails() {
    return {
        userId: '',
        refId: '',
        status: ScoreStatus.INVALID_SCORE_STATUS,
        isUserVisible: false,
        dataPoint: undefined,
    };
}
exports.CreditScoreDetails = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            refId: isSet(object.refId) ? globalThis.String(object.refId) : '',
            status: isSet(object.status)
                ? scoreStatusFromJSON(object.status)
                : ScoreStatus.INVALID_SCORE_STATUS,
        };
        if (isSet(object.isUserVisible)) {
            message.isUserVisible = globalThis.Boolean(object.isUserVisible);
        }
        if (isSet(object.dataPoint)) {
            message.dataPoint = insight_1.DataPoint.fromJSON(object.dataPoint);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.refId !== '') {
            obj.refId = message.refId;
        }
        if (message.status !== ScoreStatus.INVALID_SCORE_STATUS) {
            obj.status = scoreStatusToJSON(message.status);
        }
        if (message.isUserVisible !== undefined && message.isUserVisible !== false) {
            obj.isUserVisible = message.isUserVisible;
        }
        if (message.dataPoint !== undefined) {
            obj.dataPoint = insight_1.DataPoint.toJSON(message.dataPoint);
        }
        return obj;
    },
    create(base) {
        return exports.CreditScoreDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditScoreDetails();
        message.userId = object.userId ?? '';
        message.refId = object.refId ?? '';
        message.status = object.status ?? ScoreStatus.INVALID_SCORE_STATUS;
        message.isUserVisible = object.isUserVisible ?? false;
        message.dataPoint = (object.dataPoint !== undefined && object.dataPoint !== null)
            ? insight_1.DataPoint.fromPartial(object.dataPoint)
            : undefined;
        return message;
    },
};
function scoreStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SCORE_STATUS':
            return ScoreStatus.INVALID_SCORE_STATUS;
        case 1:
        case 'PRESENT':
            return ScoreStatus.PRESENT;
        case 2:
        case 'NO_HIT':
            return ScoreStatus.NO_HIT;
        case 3:
        case 'MISSING_SCORE_DATA':
            return ScoreStatus.MISSING_SCORE_DATA;
        case 4:
        case 'NOT_PRESENT_OTHER':
            return ScoreStatus.NOT_PRESENT_OTHER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ScoreStatus.UNRECOGNIZED;
    }
}
exports.scoreStatusFromJSON = scoreStatusFromJSON;
function scoreStatusToJSON(object) {
    switch (object) {
        case ScoreStatus.INVALID_SCORE_STATUS:
            return 'INVALID_SCORE_STATUS';
        case ScoreStatus.PRESENT:
            return 'PRESENT';
        case ScoreStatus.NO_HIT:
            return 'NO_HIT';
        case ScoreStatus.MISSING_SCORE_DATA:
            return 'MISSING_SCORE_DATA';
        case ScoreStatus.NOT_PRESENT_OTHER:
            return 'NOT_PRESENT_OTHER';
        case ScoreStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.scoreStatusToJSON = scoreStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=credit-score-changelog.js.map